import emptyFeedIcon from '@/assets/emptyFeedIcon.svg'
import ErrorViewContainer from './ErrorViewContainer'

function EmptyFeed({
  withBackButton
}: {
  withBackButton: boolean | undefined
}) {
  return (
    <ErrorViewContainer>
      <img
        src={emptyFeedIcon}
        width={449}
        height={357}
        alt="Your feed is empty right now"
      />
      <p className="font-semibold text-center">Your feed is empty right now</p>
      <p className="text-center">Stay tuned for updates.</p>
      {withBackButton && (
        <a
          href="pulsate://backbtn"
          className="mt-9 pt-2 pb-2 pl-4 pr-4 w-full block rounded font-semibold border border-black text-center">
          Go to Main Page
        </a>
      )}
    </ErrorViewContainer>
  )
}

export default EmptyFeed
